module.exports = __webpack_public_path__ + "img/search-query--empty.b6b3ea37.svg";